// extracted by mini-css-extract-plugin
export default {"formHeading":"VK-z","form":"WK-z","submitBtn":"XK-z","disabled":"YK-z","input":"ZK-z","error":"_K-z","submitMsg":"aL-z","signIn":"bL-z"};